"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SanitizeHtml = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const SanitizeHtml = ({
  html
}) => {
  const sanitizedHtml = (0, _react.useMemo)(() => ({
    __html: _dompurify.default.sanitize(html)
  }), [html]);

  // eslint-disable-next-line react/no-danger -- HTML is already sanizited
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    dangerouslySetInnerHTML: sanitizedHtml
  });
};
exports.SanitizeHtml = SanitizeHtml;
